declare global {
  interface Window {
    __LM_PORTAL_ASSET_BASE__?: string;
  }
}

const ensureTrailingSlash = (value: string) => (value.endsWith('/') ? value : `${value}/`);

const deriveBaseFromScript = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return '';
  }

  const currentScript =
    document.currentScript instanceof HTMLScriptElement
      ? document.currentScript
      : Array.from(document.getElementsByTagName('script')).find((script) => script.src.includes('portal-app'));

  if (!currentScript?.src) {
    return '';
  }

  try {
    const scriptUrl = new URL(currentScript.src, window.location.href);
    const assetsIndex = scriptUrl.pathname.lastIndexOf('/assets/');
    const basePath =
      assetsIndex >= 0
        ? scriptUrl.pathname.substring(0, assetsIndex + 1)
        : scriptUrl.pathname.substring(0, scriptUrl.pathname.lastIndexOf('/') + 1);
    return ensureTrailingSlash(`${scriptUrl.origin}${basePath}`);
  } catch (error) {
    console.warn('Unable to determine asset base path from script tag.', error);
    return '';
  }
};

const resolveAssetBaseUrl = () => {
  const baseFromWindow = typeof window !== 'undefined' ? window.__LM_PORTAL_ASSET_BASE__ : undefined;
  if (baseFromWindow && baseFromWindow.trim()) {
    return ensureTrailingSlash(baseFromWindow.trim());
  }

  const metaBase = import.meta.env.BASE_URL ?? '/';
  if (metaBase && metaBase !== '/' && metaBase !== './') {
    return ensureTrailingSlash(metaBase);
  }

  const derived = deriveBaseFromScript();
  if (derived) {
    return derived;
  }

  return '/';
};

export const assetBaseUrl = resolveAssetBaseUrl();

export const getAssetUrl = (relativePath: string) => {
  const sanitized = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  return `${assetBaseUrl}${sanitized}`;
};
